import { LinkWithPrevLocation } from '@/components/shared/LinkWithPrevLocation/LinkWithPrevLocation.tsx';
import { appRoutes } from '@/routes/app-routes.ts';

import cn from './styles.module.scss';

export const Footer = () => {
    return (
        <footer>
            <div className={cn.agsv}>© 2025, ООО «Агентство связи»</div>
            <div className={cn.policy}>
                <LinkWithPrevLocation to={appRoutes.privacyPolicy}>
                    Privacy Policy
                </LinkWithPrevLocation>
                <a href="/docs/requisites.pdf">Реквизиты</a>
            </div>
        </footer>
    );
};
